class ProductDetailPaymentHomecredit extends Component {
    linkElement;
    priceIncludingVAT;
    countElement;
    totalLoanAmountGreaterThan;
    totalLoanAmountLessThan;
    urlTemplate;

    constructor(el) {
        super(el);
        this.linkElement = this.$find('a');
        this.priceIncludingVAT = parseFloat(el.dataset.initialPrice);
        this.totalLoanAmountGreaterThan = parseFloat(el.dataset.totalLoanAmountGreaterThan);
        this.totalLoanAmountLessThan = parseFloat(el.dataset.totalLoanAmountLessThan);
        this.urlTemplate = el.dataset.urlTemplate;
        this.countElement = document.querySelector("input[name=count]");
        this.updateLink();

        this.linkElement.target = "_blank"; // otevírat v novém okně

        if (this.countElement) {
            this.countElement.addEventListener("change", () => this.updateLink());
        }
        EventBus.getInstance().addEventListener("productVariantChanged", e => this.onVariantChange(e.detail));
    }

    onVariantChange(variant) {
        if (typeof (variant.plainTextPriceVat) !== "undefined") {
            this.priceIncludingVAT = variant.plainTextPriceVat;
        }
        this.updateLink();
    }

    updateLink() {
        const countElement = document.querySelector("input[name=count]");
        const countFromElement = countElement ? parseFloat(countElement.value) : NaN;
        const count = isNaN(countFromElement) ? 1 : countFromElement;
        const totalPriceIncludingVAT = this.priceIncludingVAT * count;
        const priceString = (totalPriceIncludingVAT * 100).toFixed(0); // na haléře

        this.linkElement.href = this.urlTemplate.replace("${price}", priceString);
        this.$el.style.display = (totalPriceIncludingVAT > this.totalLoanAmountGreaterThan && totalPriceIncludingVAT < this.totalLoanAmountLessThan) ? "" : "none";
    }
}
